
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import imgUrl from "@/assets/main_user.png";

export default {
components: {
XHeader,
XImg,
Group,
Cell,
Tabbar,
TabbarItem
},
data() {
return {
defaultHeadImgUrl: imgUrl,
studyDays: 0,
myCourseCount: 0,
examDays: 0
};
},
created() {
if (this.$store.getters.getUserInfo != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=LoadCustomerInfo",
params: {
cusId: this.$store.getters.getUserInfo.CusId
}
})
.then(response => {
if (response.status == 200) {
var user = response.data.data[0];
var localUserInfo = {
CusId: user.icusid,
CusName: user.ccusname,
DcCode: user.cdccode,
HeadImgUrl: user.cheadimgurl
};
this.$store.commit("$_setUserInfo", localUserInfo);

this.studyDays = user.istudydays ? user.istudydays : 0;
this.myCourseCount = user.imycoursecount ? user.imycoursecount : 0;
this.examDays = user.iexamdays ? user.iexamdays : 0;
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
methods: {
onIndex() {
this.$router.replace({
path: "/"
});
},
onSetting() {
this.$router.push({
path: "/Setting"
});
},
onClear() {
this.$router.push({
path: "/Setting",
query: {
type: 1
}
});
},
onOpenUrl() {
window.location.href =
"http://wap.wangxiao.cn/agent/home/?agent=jinkaodian";
},
onChapter() {
this.$router.push({
path: "/ChapterExercise",
query: {
type: 0,
showTitle: "答题",
index: 1
}
});
},
onMyClass() {
this.$router.push({
path: "/MyClassList"
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/My.vue